import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Home.vue') },
  { path: '/users', component: () => import('../views/Users.vue'), meta: { permission: 'users' }, },
  { path: '/user/:id', component: () => import('../views/User.vue'), meta: { permission: 'users.edit' }, },
  { path: '/add-user', component: () => import('../views/AddUser.vue'), meta: { permission: 'users.add' }, },
  {
    path: '/settings', component: () => import('../views/Settings/Index.vue'), children: [
      { path: 'general', component: () => import('../views/Settings/General.vue') },
      { path: 'classes', component: () => import('../views/Settings/Classes.vue') },
      { path: 'avatars', component: () => import('../views/Settings/Avatars.vue') },
    ],
    meta: { permission: 'settings' },
  },
  { path: '/courses', component: () => import('../views/Courses.vue'), meta: { permission: 'courses' }, },
  {
    path: '/course', component: () => import('../views/Course/Index.vue'), children: [
      { path: 'edit/:id', component: () => import('../views/Course/Edit.vue') },
      { path: 'videos/:id', component: () => import('../views/Course/Videos.vue') },
      { path: 'students/:id', component: () => import('../views/Course/Students.vue') },
      { path: 'assistances/:id', component: () => import('../views/Course/Assistances.vue') },
    ],
    meta: { permission: 'courses.edit' },
  },
  { path: '/add-course', component: () => import('../views/AddCourse.vue'), meta: { permission: 'courses.add' }, },
  { path: '/packages', component: () => import('../views/Packages.vue'), meta: { permission: 'packages' }, },
  { path: '/attachments', component: () => import('../views/Attachments.vue') },
  { path: '/notifications', component: () => import('../views/Notifications.vue'), meta: { permission: 'notifications' }, },
  { path: '/scheduled-notifications', component: () => import('../views/ScheduledNotifications.vue'), meta: { permission: 'notifications' }, },
  { path: '/statistics', component: () => import('../views/Statistics.vue'), meta: { permission: 'statistics' }, },
  { path: '/statistics/:year/teacher/:id', component: () => import('../views/TeacherStatistics.vue'), meta: { permission: 'statistics.filter' }, },
  { path: '/statistics/:year/teacher/:id/print', component: () => import('../views/TeacherPrintInvoice.vue'), meta: { permission: 'statistics.filter' }, },
  { path: '/invoice/:invoiceId/print', component: () => import('../views/PrintSingleInvoice.vue'), meta: { permission: 'statistics.filter' }, },
  { path: '/accountants', component: () => import('../views/Accountants.vue'), meta: { permission: 'accountants' }, },
  { path: '/file-manager', component: () => import('../views/FileManager.vue'), meta: { permission: 'filemanager' }, },
  { path: '/file-manager/:folder', component: () => import('../views/FileManager.vue'), meta: { permission: 'filemanager' }, },
  { path: '/course-comparison', component: () => import('../views/CourseComparison.vue'), meta: { permission: 'courses' }, },
  { path: '/students-registration', component: () => import('../views/StudentsRegistration.vue'), meta: { permission: 'students-registration' }, },
  { path: '/whatsapp', component: () => import('../views/WhatsApp.vue'), meta: { permission: 'whatsapp' }, },
  { path: '/campaigns', component: () => import('../views/Campaigns.vue'), meta: { permission: 'campaigns' }, },
  { path: '/requests', component: () => import('../views/CardsRequests.vue'), meta: { permission: 'campaigns' }, },
  { path: '/otp', component: () => import('../views/OtpLog.vue'), meta: { permission: 'otp' }, },
  { path: '/403', component: () => import('../views/Forbidden.vue') },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
